// wac-management-service publishes exactly these three routing-table objects
// (see RoutingTableEnvironment in wac-management-service/src/routing-table/constants.ts).
// It has no dev-specific object, so a dev or local build reads the staging object,
// the same content-environment its sibling WAC_MANAGEMENT_CDN/PREVIEW_CDN vars use.
const MANAGEMENT_ROUTING_TABLE_FILE_NAMES: Record<string, string> = {
	production: 'routing-table-production.json',
	staging: 'routing-table-staging.json',
	dev: 'routing-table-staging.json',
	local: 'routing-table-staging.json',
};

export const fetchRoutingTable = async () => {
	try {
		const isPreview =
			window.location.search.includes('wacae-preview=true') &&
			process.env['NODE_ENV'] !== 'production';

		if (isPreview) {
			console.log('wacae-preview is true, fetching Preview Routing Table');
		}

		const baseUrl = process.env['WAC_MANAGEMENT_ROUTING_TABLE_BASE_URL'] as string;
		const fileName = isPreview
			? 'routing-table-preview.json'
			: (MANAGEMENT_ROUTING_TABLE_FILE_NAMES[process.env['NODE_ENV'] as string] ??
				'routing-table-staging.json');
		const routingTableUrl = `${baseUrl}/${fileName}`;

		const response = await fetch(routingTableUrl);
		if (!response.ok) {
			throw new Error(
				`Failed to fetch Routing Table from CloudFront: ${response.status} ${response.statusText}`,
			);
		}
		return await response.json();
	} catch (error) {
		console.error('Error fetching Routing Table', error);
	}
};

const ROUTING_TABLE_METADATA_KEYS = new Set(['x']);

export const inRoutingTable = (
	segments: string[],
	index: number,
	segLength: number,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	routeObject: any,
): boolean => {
	const currSeg = String(segments[index]);
	const hasSeg = ROUTING_TABLE_METADATA_KEYS.has(currSeg) ? undefined : routeObject[currSeg];
	const hasWildcard = routeObject['*'];
	const lastSeg = index === segLength;

	let hasSegResult = false;
	let hasWildcardResult = false;

	if (hasSeg) {
		if (lastSeg) {
			hasSegResult = !Boolean(hasSeg['p']);
		} else {
			hasSegResult = inRoutingTable(segments, index + 1, segLength, hasSeg);
		}
	}

	if (hasWildcard) {
		if (lastSeg) {
			hasWildcardResult = !Boolean(hasWildcard['p']);
		} else {
			hasWildcardResult = inRoutingTable(segments, index + 1, segLength, hasWildcard);
		}
	}

	return hasSegResult || hasWildcardResult;
};
